module.exports = "<div class=\"width-limiter\">\n    &copy; <span class=\"logo\"></span> 2019-{{currentYear}}\n</div>\n"